import React from 'react'

const LookupTabsLegend = () => (
  <span className="lookup-tabs__legend">
    <span className="lookup-tabs__legend-swatch lookup-tabs__legend-swatch--lot" aria-hidden="true" />
    Tax lot data
    <span className="lookup-tabs__legend-swatch lookup-tabs__legend-swatch--building" aria-hidden="true" />
    Building-specific data
  </span>
)

export default LookupTabsLegend
